import { handleLocalStorage } from '@utils';

import { loginActions } from '@modules/login';
import { TMiddleware } from '@modules/types';

const { setItem } = handleLocalStorage;
const actions = [loginActions.keepAlive.fulfilled.type, loginActions.keepAlive.pending.type];

export const setIdleTimeout: TMiddleware = store => next => action => {
  const { user } = store.getState();
  const idleTimestamp = new Date().getTime();
  const shouldUpdate = user.data && actions.includes(action.type);

  if (shouldUpdate) setItem('idle_timestamp', idleTimestamp);
  return next(action);
};

export default setIdleTimeout;
